import { Injectable } from "@angular/core";
import { ApiService } from "../../core/services/api.service";
import { UsersDTO } from "../../shared/DTO/UsersDTO";
import { SessionStateService } from "../../core/services/session-state.service";
import { User, HouseUser } from "./profile.model";
import { HouseUserDTO } from "../../shared/DTO/UserDTO";

@Injectable()
export class ProfileService {
  constructor(
    private apiService: ApiService,
    private sessionStateService: SessionStateService
  ) {}

  getUsers() {
    return this.apiService
      .get(
        "/usermanagement/house/" +
          this.sessionStateService.getHouse().houseId +
          "/user"
      )
      .map((users) => UsersDTO.fromDto(users));
  }

  getUser() {
    const userId = this.sessionStateService.getUserId();
    return this.apiService
      .get(`/usermanagement/user?${userId}`)
      .map((response) => UsersDTO.fromDtoSingle(response.User));
  }

  addUser(houseUser: HouseUser) {
    return this.apiService.post(
      "/usermanagement/house/" +
        this.sessionStateService.getHouse().houseId +
        "/user",
      HouseUserDTO.toHouseUserDto(houseUser)
    );
  }

  editUser(firstName: string, lastName: string, languageCode: string) {
    const body = {
      firstName: firstName,
      lastName: lastName,
      languageCode: languageCode,
    };

    const userId = this.sessionStateService.getUserId();
    return this.apiService.put(`/usermanagement/user?'${userId}`, body);
  }

  editUserAccess(
    receiveReport: boolean,
    receiveEmail: boolean,
    receivePush: boolean
  ) {
    const body = {
      receiveReport: receiveReport,
      receiveEmail: receiveEmail,
      receivePush: receivePush,
    };

    return this.apiService.put(
      "/usermanagement/house/" +
        this.sessionStateService.getHouse().houseId +
        "/user",
      body
    );
  }

  removeUser(email: string) {
    const userId = this.sessionStateService.getUserId();
    return this.apiService.delete(
      "/usermanagement/house/" +
        this.sessionStateService.getHouse().houseId +
        "/user?" +
        userId +
        "&email=" +
        email
    );
  }

  getUserPermission() {
    return this.apiService.get(
      "/usermanagement/house/" +
        this.sessionStateService.getHouse().houseId +
        "/user/access"
    );
  }

  patchHouseInfo(
    name: string,
    address: string,
    city: string,
    district: string,
    postalCode: string
  ) {
    const houseId = this.sessionStateService.getHouse().houseId;
    const body = {
      houseinfo: {
        name: name,
        address: address,
        city: city,
        district: district,
        postalCode: postalCode,
      },
    };
    return this.apiService.patch(`/equipment/houses/${houseId}`, body);
  }

  acceptPrivacyPolicy() {
    return this.apiService.put(
      `/usermanagement/user/accept-privacy-policy`,
      {}
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/profile/profile.service.ts